import { Snap, ValidationResult } from '@inter-ikea-core/core';
import { CoreApi, PlannerValidation } from '@inter-ikea-storageone/range';

// Validation rule to only snap to back wall when playing Ekris game
export class EkrisSingleWallValidation extends PlannerValidation {
  coreApi: CoreApi;

  constructor(coreApi: CoreApi) {
    super(coreApi, 'WallVisibilityValidation');
    this.coreApi = coreApi;
  }

  validateCurrentState(): ValidationResult | null {
    return this.validationOK();
  }

  validateSnap(snapActionCandidate: Snap): ValidationResult | null {
    const rotation = snapActionCandidate.endTransform.rotation.toEulerDegrees();
    return Math.round(rotation.Y) !== 0
      ? this.validationFail('Only snap to back wall')
      : this.validationOK();
  }
}
